import { request2 } from 'utils/request';

function uploadGpxFile({ gpx, description, user }) {
  return request2({
    url: '/import/gpx',
    method: 'POST',
    body: { gpx, description },
    user,
    // A retry after a lost response would import the route twice
    retry: false,
  });
}

export default uploadGpxFile;
